// Tiny classname joiner (no dependency; filters falsy).
export const cx = (
  ...parts: Array<string | number | false | null | undefined>
): string => parts.filter(Boolean).join(" ");
